<!--
 * @Description: 中间地图
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-25 15:14:43
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-23 13:26:53
 -->
<template>
  <div class="bottom-center-map">
    <dv-flyline-chart-enhanced :dev="true" :config="mapConfig" style="width:100%;height:100%;" />
  </div>
</template>

<script>
export default {
  name: 'bottomCenterMap',
  components: {
  },
  data () {
    return {
      mapConfig: {},
    }
  },
  methods: {
    /**
     * @description                   获取地图数据
     * @return {undefied}             无返回值
     */
    getDeployMapData () {
      this.$http.get('/rest/screen/operation/projectDeptList', {
        provinceId: 410000,
      }).then(res => {
        if (res.code === 0) {
          let points = [
            {
              name: '郑州市',
              coordinate: [0.52, 0.31],
              icon: {
                src: '/static/img/layout/mapCenterPoint.png',
                width: 30,
                height: 30,
              },
              halo: {
                show: true,
              },
              text: {
                color: '#00ffee',
              },
            },
          ]
          let lines = []
          res.data.map(item => {
            if (item.cityPosition) {
              points.push({
                name: item.cityName,
                coordinate: [parseFloat(item.cityPosition.split(',')[0]), parseFloat(item.cityPosition.split(',')[1])],
              })
              lines.push({
                radius: 60,
                width: 2,
                source: '郑州市',
                target: item.cityName,
              })
            }
          })
          this.mapConfig = {
            bgImgSrc: '/static/img/layout/map-henan.png',
            points: points,
            lines: lines,
            icon: {
              show: true,
              src: '/static/img/layout/mapPoint.png',
            },
            text: {
              show: true,
            },
          }
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
          })
        }
      })
    },
  },
  created () {
    this.getDeployMapData()
  },
}
</script>

<style lang="less" scoped>
  .bottom-center-map {
    height: 92%;
    aspect-ratio: 6.43/6.14;
  }
</style>
